import {gql} from 'apollo-angular';
import {JobPreviewFragment} from "./fragments/JobPreview";

export const GET_JOBS_SEARCH_RESULTS = gql`
  query GetJobsSearchResults ($search: String!) {
    jobMarkets(search: $search) {
      numResults
      entries {
        ...jobPreviewFields
      }
    }
  }
  ${JobPreviewFragment}
`;
